/**
 * Copyright (c) 2017
 *
 * Load JavaScript and CSS files to the DOM
 *
 * @summary Load js and css files to the DOM
 * @author Anders Hjelm <anders.hjelm@teliacompany.com>
 *
 * Created at     : 2019-12-05
 */

import { createLogger } from '@telia-ace/edge-log';

const log = createLogger('utils/fileUtils');

export const loadCSS = (fileObj) => {
  const link = document.createElement('link');
  // Default properties
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.media = 'all';
  // Pick up the configured properties. href must be there!
  Object.assign(link, fileObj);

  log.trace('Load CSS:', link);
  document.head.appendChild(link);
};

export function loadJS(fileObj) {
  const promise = new Promise((resolve, reject) => {
    const scr = document.createElement('script');
    scr.onerror = (err) =>
      reject(new Error(`Failed to load${JSON.stringify(fileObj)} error: ${err.message}`));
    scr.onload = resolve;
    scr.async = true;
    // Default properties
    scr.type = 'text/javascript';
    // Pick up the configured properties. src must be there!
    Object.assign(scr, fileObj);

    try {
      log.trace('Load script:', scr.src);
      if (!document.body) {
        document.head.appendChild(scr);
      } else {
        document.body.appendChild(scr);
      }
    } catch (err) {
      reject(err);
    }
  });
  return promise;
}

export function splitPathAndFilename(url) {
  const path = url.substring(0, url.lastIndexOf('/') + 1);
  const fileName = url.substring(url.lastIndexOf('/') + 1);
  return { path, fileName };
}
